export default "__VITE_ASSET__nSUH8JIv__"